import { RuleCategory } from '../../../../common/enums/RuleCategory';
import { Ruleset } from '../../../../common/enums/Ruleset';

export class AnalyzerRule {
  constructor(
    protected readonly number: number,
    protected readonly title: string,
    protected readonly category: RuleCategory,
    protected readonly ruleset: Ruleset,
    protected readonly shortExplanation: string
  ) {}

  getNumber() {
    return this.number;
  }

  getTitle() {
    return this.title;
  }

  getCategory() {
    return this.category;
  }

  getRuleset() {
    return this.ruleset;
  }

  getShortExplanation() {
    return this.shortExplanation;
  }
}
